import { module } from 'modujs';
import Lottie from 'lottie-web';
import { Swiper, Navigation, Lazy, Parallax, Pagination, Autoplay } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        Swiper.use([Navigation, Lazy, Parallax, Pagination, Autoplay]);

        this.length = this.$('item').length
        this.container = this.$('container')[0]
        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]
        this.pagination = this.$('pagination')[0]
        this.titleWords = this.$('title')[0].querySelectorAll('.c-carousel-lottie_title_item')
        this.initialLotties = this.$('lottie') // getting only the initial lotties, not the duplicated ones
        this.allLotties = []; // At each load, this.allLoties gets a new row with the lottie object so we can access to it

        this.visibilityBind = this.onVisibilityChange.bind(this);
        document.addEventListener("visibilitychange", this.visibilityBind);

        const args = {
            speed: 1200,
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1,
            threshold: 3,
            preloadImages: false,
            parallax: true,
            lazy: {
                loadPrevNext: true,
            },
            autoplay: {
                disableOnInteraction: false,
            },
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            },
            pagination: {
                el: this.pagination,
                type: 'bullets',
                clickable: true
            }
        }

       // Lottie.setLocationHref()

        this.currentLottieIndex = 0
        this.loadLottie(this.initialLotties[0], this.currentLottieIndex) // Loading the first one

        this.direction = {
            prev: false, 
            next: false
        }

        if(this.length > 1) {
            this.carousel = new Swiper(this.container, args)
            this.currentProgress = this.carousel.progress
            this.carousel.on('slideChange', (e) => this.highlightWord(e.realIndex)) // Highlight wording
            this.carousel.on('transitionEnd', () => this.transitionEnd()) // Reset all others lotties
            this.carousel.on('progress', (swiper, progress) => this.moving(progress)) // Play the next lottie (prev / next)
        } else {
            this.pagination.classList.add('u-visibility-hidden')
            this.arrowPrev.classList.add('u-visibility-hidden')
            this.arrowNext.classList.add('u-visibility-hidden')
        }
    }

    loadLottie(el, i) {
        this.allLotties[i] = Lottie.loadAnimation({
            container: el,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: el.getAttribute('data-animation-path')
        })
        el.dataset.index = i
        this.currentLottie = this.allLotties[i]
    }

    onVisibilityChange() {
        const state = document.visibilityState
        if(state == "hidden") {
            this.currentLottie?.pause()
        } else {
            this.currentLottie?.goToAndPlay(0)
        }
    }

    /* If lotties are reset, we'll see an empty one at the "reloop" moment
    Because of the duplicated DOM
    resetLottie(lottie) {
        lottie.goToAndStop(0, true)
    } */

    playLottie(el) {
        this.allLotties[el.dataset.index].goToAndPlay(0)
        this.currentLottie = this.allLotties[el.dataset.index]
    }

    moving(progress) {
        if (progress > this.currentProgress && !this.direction.next) { // Going next
            this.direction = {
                prev: false, 
                next: true
            }
            const nextLottie = document.querySelector('.swiper-slide-next .c-carousel-lottie_lottie')
            nextLottie.innerHTML.length === 0 ? this.loadLottie(nextLottie, ++this.currentLottieIndex) : this.playLottie(nextLottie)
        } else if (progress < this.currentProgress && !this.direction.prev) { // Going prev
            this.direction = {
                prev: true, 
                next: false
            }
            const prevLottie = document.querySelector('.swiper-slide-prev .c-carousel-lottie_lottie')
            prevLottie.innerHTML.length === 0 ?  this.loadLottie(prevLottie, ++this.currentLottieIndex) : this.playLottie(prevLottie)
        }
    }

    highlightWord(i) {
        for (var j = this.titleWords.length - 1; j >= 0; j--) {
            if (this.titleWords[j].classList.contains('is-active')) {
                this.titleWords[j].classList.remove('is-active')
                break
            }
        }
        this.titleWords[i].classList.add('is-active')
    }

    transitionEnd() {
        /* If lotties are reset, we'll see an empty one at the "reloop" moment 
        Because of the duplicated DOM
        for (var i = this.allLotties.length - 1; i >= 0; i--) {
            if (!this.allLotties[i].wrapper.parentNode.classList.contains('swiper-slide-active')) {
                this.resetLottie(this.allLotties[i])
            }
        } */

        this.currentProgress = this.carousel.progress
        this.direction = {
            prev: false, 
            next: false
        }
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy()
        for (var i = this.allLotties.length - 1; i >= 0; i--) {
            if (this.allLotties[i]) this.allLotties[i].destroy()
        }

        document.removeEventListener("visibilitychange", this.visibilityBind);
    }
}
